import { Routes, Route } from 'react-router-dom'
import { PAGE_URLS } from '@/lib/constants'

// Pages - will be created next
import HomePage from '@/features/home/HomePage'
import AboutPage from '@/features/about/AboutPage'
import ContactPage from '@/features/contact/ContactPage'
import FacilitiesPage from '@/features/facilities/FacilitiesPage'
import ActivitiesPage from '@/features/activities/ActivitiesPage'
import ServicesPage from '@/features/services/ServicesPage'
import GalleryPage from '@/features/gallery/GalleryPage'
import NotFoundPage from '@/features/not-found/NotFoundPage'

function App() {
  return (
    <Routes>
      <Route path={PAGE_URLS.HOME} element={<HomePage />} />
      <Route path={PAGE_URLS.ABOUT_US} element={<AboutPage />} />
      <Route path={PAGE_URLS.CONTACT} element={<ContactPage />} />
      <Route path={PAGE_URLS.FACILITIES} element={<FacilitiesPage />} />
      <Route path={PAGE_URLS.ACTIVITIES} element={<ActivitiesPage />} />
      <Route path={PAGE_URLS.SERVICES} element={<ServicesPage />} />
      <Route path={PAGE_URLS.GALLERY} element={<GalleryPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default App
